import React, { useState } from 'react';
import { useBookmarks } from '../../context/BookmarksContext';
import '../AddToListModal/AddToListModal.css';

const BookmarkModal = ({ author, permlink, onClose }) => {
  const { folders, createFolder, toggleBookmark } = useBookmarks();
  const [newFolderName, setNewFolderName] = useState('');
  const [creating, setCreating] = useState(false);
  const [createError, setCreateError] = useState('');
  const [pendingToggles, setPendingToggles] = useState({});

  const handleToggle = async (folderId) => {
    if (pendingToggles[folderId]) return;
    setPendingToggles(prev => ({ ...prev, [folderId]: true }));
    try {
      await toggleBookmark(folderId, author, permlink);
    } catch (err) {
      console.error('Toggle bookmark failed:', err.message);
    } finally {
      setPendingToggles(prev => ({ ...prev, [folderId]: false }));
    }
  };

  const handleCreate = async () => {
    const name = newFolderName.trim();
    if (!name) return;
    setCreating(true);
    setCreateError('');
    try {
      const folder = await createFolder(name);
      setNewFolderName('');
      // Auto-add the item to the newly created folder
      await toggleBookmark(folder.id, author, permlink);
    } catch (err) {
      setCreateError(err.response?.data?.error || 'Failed to create folder');
    } finally {
      setCreating(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleCreate();
    if (e.key === 'Escape') onClose();
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="add-to-list-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Add to Bookmarks</h2>
          <button className="close-btn" onClick={onClose} aria-label="Close">×</button>
        </div>

        <div className="add-to-list-body">
          {folders.length === 0 && (
            <p className="no-lists-hint">No bookmark folders yet. Create one below.</p>
          )}

          <ul className="list-items">
            {folders.map(folder => {
              const isMember = folder.items?.some(item => item.author === author && item.permlink === permlink);
              const pending = !!pendingToggles[folder.id];
              return (
                <li key={folder.id} className="list-item">
                  <button
                    className={`list-toggle-btn ${isMember ? 'is-member' : ''}`}
                    onClick={() => handleToggle(folder.id)}
                    disabled={pending}
                  >
                    <span className="list-check">{isMember ? '✓' : ''}</span>
                    <span className="list-name">{folder.name}</span>
                    <span className="list-count">{folder.items ? folder.items.length : 0}</span>
                  </button>
                </li>
              );
            })}
          </ul>

          <div className="create-list-row">
            <input
              className="create-list-input"
              type="text"
              placeholder="New folder name…"
              value={newFolderName}
              onChange={e => setNewFolderName(e.target.value)}
              onKeyDown={handleKeyDown}
              maxLength={100}
            />
            <button
              className="create-list-btn"
              onClick={handleCreate}
              disabled={creating || !newFolderName.trim()}
            >
              {creating ? '…' : 'Create'}
            </button>
          </div>
          {createError && <p className="create-list-error">{createError}</p>}
        </div>
      </div>
    </div>
  );
};

export default BookmarkModal;
